import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../store/auth";
import { toast } from "react-toastify";
import { Autocomplete, TextField, InputAdornment } from "@mui/material";
import map_logo from "../../../map-icon.png"
import number_logo from "../../../Assets/91.png"

export default function EditSelfDrives({setIsLoading}) {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    subcate:"",
    purpose:"",
    fuel: "",
    brand: "",
    transmission: "",
    price: "",
    title: "",
    description: "",
    aria: "",
    wnumber: "",
  });

  useEffect(() => {
    // Fetch car details and set the form data
    const fetchCarDetails = async () => {
      try {
        const response = await fetch(`https://in.quiko.in/api/sell/selfdrives/${id}`, {
          method: "GET",
        });
        const data = await response.json();
        const dataValue = data.response_data;

        if(response.ok){
          setFormData({
            title: dataValue.title,
            price: dataValue.price,
            subcate: dataValue.subcate,
            purpose:dataValue.purpose,
            transmission:dataValue.transmission,
            fuel: dataValue.fuel,
            description: dataValue.description,
            aria: dataValue.aria,
            brand : dataValue.brand,
            wnumber: dataValue.wnumber,
          });
        }
        
      } catch (error) {
        console.log("Error fetching Post details: ");
      }
    };

    fetchCarDetails();
  }, [id]);

  const handleAutocompleteChange = (event, value) => {
    setFormData({ ...formData, aria: value || "" });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.price >= 0 && formData.price <= 10) {
      toast.error("Please enter a price greater than 10.");
      return;
    }
    
    setIsLoading(true)
    try {
      const response = await fetch(`https://in.quiko.in/api/sell/selfdrives/edit/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        toast.success("Post details updated successfully!");
        navigate("/");
      } else {
        toast.error("Failed to update Post details. Post not found");
      }
    } catch (error) {
      toast.error("Error updating Post details.");
    }finally{
      setIsLoading(false)
    }
  };

  const [myOptions, setMyOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const getDataFromAPI = async (event) => {
    const value = event.target.value;
    setFormData({ ...formData, aria: value }); // Update location in formData
    setErrorMessage(""); // Clear any previous error message

    if (value.length > 2) {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${value}&format=json`
        );

        if (!response.ok) {
          throw new Error("No Location Found");
        }

        const results = await response.json();
        setMyOptions(results.map((result) => result.display_name));
      } catch (error) {
        setErrorMessage("No location found"); // Set error message if fetch fails
      }
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-content">
        <h1>SelfDrives </h1>
        <form onSubmit={handleSubmit}>


          <div className="mb-3">
            <label htmlFor="exampleInputText" className="form-label">
              Brand*
            </label>
            <input
              type="text"
              name="brand"
              className="form-control"
              id="barnd"
              value={formData.brand}
              
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <select
              name="subcate"
              className="form-select form-select-sm"
              aria-label="Small select example"
              id="subcate"
              onChange={handleChange}
              value={formData.subcate}
            >
              <option selected="">Category*</option>
              <option value="cars">Cars</option>
              <option value="bikes">Bikes</option>
              <option value="others">Others</option>
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="exampleInputNumber" className="form-label">
              Price*
            </label>
            <input
              type="number"
              name="price"
              className="form-control"
              id="price"
              value={formData.price}
              
              onChange={handleChange}
            />
            {formData.price >= 0 && formData.price <= 10 && (
               <div style={{ color: "red" }}>
                Please enter a price greater than 10.
                </div>
            )}
          </div>

          <div className="mb-3">
            <select
              name="fuel"
              className="form-select form-select-sm"
              id="fuel"
              aria-label="Small select example"
              value={formData.fuel}
              onChange={handleChange}
              
            >
              <option value="">Fuel*</option>
              <option value="CNG & Hybrid">CNG & Hybrid</option>
              <option value="Diesel">Diesel</option>
              <option value="Electric">Electric</option>
              <option value="LPG">LPG</option>
              <option value="Petrol">Petrol</option>
            </select>
          </div>

          <div className="mb-3">
            <select
              name="transmission"
              className="form-select form-select-sm"
              aria-label="Small select example"
              id="transmission"
              value={formData.transmission}
              onChange={handleChange}
              
            >
              <option selected="">Transmission*</option>
              <option value="Automatic">Automatic</option>
              <option value="Manual">Manual</option>
            </select>
          </div>

          
          <div className="mb-3">
            <select
              name="purpose"
              id="purpose"
              className="form-select form-select-sm"
              aria-label="Small select example"
              onChange={handleChange}
              value={formData.purpose}
            >
              <option selected="">Purpose *</option>
              <option value="wedding">Wedding</option>
              <option value="personalused">Personal Used</option>
              <option value="tours">Tours & Travels</option>
              <option value="others">For Others Occations</option>
              <option value="all">For All</option>
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="exampleInputText" className="form-label">
              Ad title*
            </label>
            <input
              type="text"
              name="title"
              className="form-control"
              id="title"
              value={formData.title}
              
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="exampleInputText" className="form-label">
              Description*
            </label>
            <textarea
              type="text"
              name="description"
              className="form-control"
              id="description"
              cols="30"
              rows="4"
              value={formData.description}
              
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="aria" className="form-label">
              Location*
            </label>
            <Autocomplete
              style={{
                width: "100%",
                height: 50,
                background: "white",
                borderRadius: 20,
              }}
              freeSolo
              autoComplete
              autoHighlight
              options={myOptions}
              onInputChange={getDataFromAPI} // Update suggestions on input change
              onChange={handleAutocompleteChange} // Set full location on selection
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  
                  placeholder="Select your Area, State"
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      height: 50,
                      borderRadius: 20,
                      border: "1px solid black",
                      fontSize: "16px",
                      fontWeight: "700",
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={map_logo}
                          alt="Search Icon"
                          style={{ width: 26, height: 30 }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
            {errorMessage && (
              <div style={{ color: "red", marginTop: "10px" }}>
                {errorMessage}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="exampleInputNumber" className="form-label">
              Your Whatsapp Number*(without country code, e.g., 91)
            </label>
            <TextField
              type="text"
              name="wnumber"
              className="form-control"
              id="wnumber"
              placeholder=" 1234567890"
              
              value={formData.wnumber}
              onChange={handleChange}
              InputProps={{
                
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={number_logo} // Your logo image
                      alt="Logo"
                      style={{ width: 50, height: 50 }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </div>

          {/* <div className="mb-3">
            <label htmlFor="exampleInputText" className="form-label">
              Upload multiple image* ( Maximum 4 images are upload )
            </label>
            <input
              type="file"
              name="image"
              className="form-control"
              id="image"
              multiple
              
              onChange={handleFileChange}
            />
          </div> */}

          <button type="submit" className="form-submit-button">
            Update Post
          </button>
        </form>
      </div>
    </div>
  );
}
